import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const LoaderWrapper = styled(Flex)`
    position: relative;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
`;
